/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CorrectionDashboardDetailItemRepositoryResponsePaginatedResponse } from "../types/CorrectionDashboardDetailItemRepositoryResponsePaginatedResponse.ts";
import { correctionDashboardDetailItemRepositoryResponseSchema } from "./correctionDashboardDetailItemRepositoryResponseSchema.ts";

export const correctionDashboardDetailItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(
        z.lazy(() => correctionDashboardDetailItemRepositoryResponseSchema),
      )
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<CorrectionDashboardDetailItemRepositoryResponsePaginatedResponse>;
